/**
 * Timezone Interceptor (DEV-381)
 * Автоматическое добавление заголовка user-timezone (IANA-зона браузера).
 * Бэкенд (calendar) использует его для сравнения all-day записей по дате в таймзоне
 * пользователя. Берём зону через Intl, без обращения к Pinia-стору — по аналогии с
 * auth-интерцептором (он читает токен из localStorage), чтобы избежать циклических
 * импортов и зависимости от готовности стора.
 */
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

export function setupTimezoneInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (config.headers) {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (tz) {
          config.headers['user-timezone'] = tz
        }
      }

      return config
    },
    (error) => Promise.reject(error),
  )
}
